import React, { Component } from 'react';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';

const data = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];

const COLORS = ['#365f94', '#8faadc', '#424f60', '#ffc30c','#bbcce2','#7d5c94','#203864','#ed7d31','#4472c4','#34a4e4'];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" className='text-sm'>
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const renderActiveShape = props => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 0}
        outerRadius={outerRadius + 10}
        fill={fill}
        opacity={0.2}
      />
    </g>
  );
};

export default class PieChartPanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: null,
    };

    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  onMouseOver (data, index) {
    this.setState({ activeIndex : index });
  }
  onMouseLeave (data, index) {
    this.setState({ activeIndex: null });
  }

  render() {
    const { _data } = this.props;
    const { activeIndex } = this.state;

    return (
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={400} height={400}>
          <Pie
            data={_data}
            cx="50%"
            cy="50%"
            labelLine={false}
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
            opacity={activeIndex === null ? 1 : 0.25}
            onMouseEnter={(data, index) => this.onMouseOver(data, index)}
            onMouseLeave={() => this.onMouseLeave()}
          >
            {_data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

